import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from '../ui/CTAButton';
const reviews = [{
  name: 'Laura M.',
  location: 'Madrid',
  initial: 'L',
  color: 'bg-blue-500',
  time: 'hace 2 semanas',
  rating: 5,
  text: 'Llevaba meses intentando comer mejor pero siempre acababa tirando la toalla. Con este megapack empecé a cocinar con la airfryer de otra manera. Las recetas son rápidas y están buenísimas. Llevo 3 semanas y no siento que esté a dieta para nada.'
}, {
  name: 'Carlos R.',
  location: 'Valencia',
  initial: 'C',
  color: 'bg-red-500',
  time: 'hace 1 mes',
  rating: 5,
  text: 'Trabajo muchas horas y no tenía tiempo para cocinar sano. El sistema de batch cooking me cambió la vida. Preparo todo el domingo y tengo comida saludable para toda la semana. Muy recomendable.'
}, {
  name: 'Ana G.',
  location: 'Barcelona',
  initial: 'A',
  color: 'bg-green-600',
  time: 'hace 3 semanas',
  rating: 5,
  text: 'Tenía la airfryer cogiendo polvo y ahora la uso todos los días. El tomo de recetas del día a día es increíble, el pollo crujiente saludable lo hago dos veces por semana. Muy contenta con la compra.'
}, {
  name: 'María T.',
  location: 'Sevilla',
  initial: 'M',
  color: 'bg-yellow-500',
  time: 'hace 5 días',
  rating: 5,
  text: 'Antes improvisaba siempre y acababa pidiendo comida a domicilio. Ahora tengo el menú de la semana planificado y una lista de compra clara. He bajado 3 kilos en un mes sin pasar hambre.'
}, {
  name: 'Javier P.',
  location: 'Zaragoza',
  initial: 'J',
  color: 'bg-purple-500',
  time: 'hace 2 meses',
  rating: 5,
  text: 'Lo mejor es que no parece una dieta. Comes bien, comes rico y poco a poco ves resultados. Los postres saludables son un descubrimiento, los brownies de la airfryer están increíbles.'
}];
function StarRating({
  count
}: {
  count: number;
}) {
  return <div className="flex gap-0.5" data-id="element-205">
      {Array.from({
      length: count
    }).map((_, i) => <svg key={i} className="w-4 h-4 fill-[#FBBC04]" viewBox="0 0 24 24" data-id="element-206">
          <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" data-id="element-207" />
        </svg>)}
    </div>;
}
export function TestimonialsFAQSection() {
  return <section className="py-10 md:py-14 px-4 bg-gray-50 text-center" data-id="element-208">
      <div className="max-w-3xl mx-auto" data-id="element-209">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-210">
          {/* GOOGLE REVIEWS */}
          <div className="mb-10" data-id="element-211">
            {/* Google Reviews Header */}
            <div className="flex flex-col items-center mb-6" data-id="element-212">
              <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-3" data-id="element-213">
                Lo que dicen otras personas
              </h2>
              <div className="flex items-center gap-3 bg-white px-5 py-3 rounded-2xl shadow-md border border-gray-100" data-id="element-214">
                {/* Google G logo */}
                <svg className="w-6 h-6 flex-shrink-0" viewBox="0 0 24 24" data-id="element-215">
                  <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" data-id="element-216" />
                  <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" data-id="element-217" />
                  <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" data-id="element-218" />
                  <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" data-id="element-219" />
                </svg>
                <div className="text-left" data-id="element-220">
                  <div className="flex items-center gap-2" data-id="element-221">
                    <span className="text-2xl font-black text-gray-900" data-id="element-222">
                      4.9
                    </span>
                    <StarRating count={5} data-id="element-223" />
                  </div>
                  <p className="text-xs text-gray-500" data-id="element-224">
                    Basado en 127 reseñas de Google
                  </p>
                </div>
              </div>
            </div>

            <div className="space-y-3 text-left" data-id="element-225">
              {reviews.map((review, idx) => <div key={idx} className="bg-white p-4 rounded-2xl shadow-sm border border-gray-100" data-id="element-226">
                  <div className="flex items-start gap-3" data-id="element-227">
                    {/* Avatar */}
                    <div className={`${review.color} w-10 h-10 rounded-full flex items-center justify-center text-white font-bold text-lg flex-shrink-0`} data-id="element-228">
                      {review.initial}
                    </div>
                    <div className="flex-1 min-w-0" data-id="element-229">
                      <div className="flex items-center justify-between flex-wrap gap-1" data-id="element-230">
                        <div data-id="element-231">
                          <p className="font-bold text-gray-900 text-sm" data-id="element-232">
                            {review.name}
                          </p>
                          <p className="text-xs text-gray-400" data-id="element-233">
                            {review.location}
                          </p>
                        </div>
                        {/* Google G small */}
                        <svg className="w-4 h-4 flex-shrink-0" viewBox="0 0 24 24" data-id="element-234">
                          <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" data-id="element-235" />
                          <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" data-id="element-236" />
                          <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" data-id="element-237" />
                          <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" data-id="element-238" />
                        </svg>
                      </div>
                      <div className="flex items-center gap-2 mt-1 mb-2" data-id="element-239">
                        <StarRating count={review.rating} data-id="element-240" />
                        <span className="text-xs text-gray-400" data-id="element-241">
                          {review.time}
                        </span>
                      </div>
                      <p className="text-sm text-gray-700 leading-relaxed" data-id="element-242">
                        {review.text}
                      </p>
                    </div>
                  </div>
                </div>)}
            </div>
          </div>

          {/* FAQ */}
          <div className="mb-10" data-id="element-243">
            <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-6" data-id="element-244">
              Preguntas frecuentes
            </h2>

            <div className="space-y-3 text-left max-w-2xl mx-auto" data-id="element-245">
              <div className="bg-white p-4 rounded-xl shadow-sm border border-gray-200" data-id="element-246">
                <h3 className="text-base font-bold text-gray-900 mb-1" data-id="element-247">
                  ¿Necesito saber cocinar?
                </h3>
                <p className="text-sm text-gray-600" data-id="element-248">
                  No. Las recetas están diseñadas para principiantes.
                </p>
              </div>
              <div className="bg-white p-4 rounded-xl shadow-sm border border-gray-200" data-id="element-249">
                <h3 className="text-base font-bold text-gray-900 mb-1" data-id="element-250">
                  ¿Necesito una airfryer?
                </h3>
                <p className="text-sm text-gray-600" data-id="element-251">
                  Sí, el método está diseñado para cocinar con airfryer.
                </p>
              </div>
              <div className="bg-white p-4 rounded-xl shadow-sm border border-gray-200" data-id="element-252">
                <h3 className="text-base font-bold text-gray-900 mb-1" data-id="element-253">
                  ¿El material es digital?
                </h3>
                <p className="text-sm text-gray-600" data-id="element-254">
                  Sí. Acceso inmediato desde cualquier dispositivo.
                </p>
              </div>
              <div className="bg-white p-4 rounded-xl shadow-sm border border-gray-200" data-id="element-255">
                <h3 className="text-base font-bold text-gray-900 mb-1" data-id="element-256">
                  ¿Cuándo recibo el material?
                </h3>
                <p className="text-sm text-gray-600" data-id="element-257">
                  Inmediatamente después de completar la compra.
                </p>
              </div>
            </div>
          </div>

          {/* FINAL CTA */}
          <div className="bg-gray-900 text-white rounded-3xl p-6 md:p-10 shadow-2xl" data-id="element-258">
            <h2 className="text-3xl md:text-4xl font-extrabold mb-3 text-yellow-400" data-id="element-259">
              Bajar de peso puede ser mucho más simple
            </h2>
            <div className="text-lg md:text-xl font-medium space-y-1 mb-5" data-id="element-260">
              <p data-id="element-261">No necesitas dietas extremas.</p>
              <p data-id="element-262">Necesitas un sistema práctico que puedas mantener.</p>
            </div>
            <p className="text-xl font-bold mb-5" data-id="element-263">👉 Empieza hoy mismo</p>
            <CTAButton href="#compra" text="QUIERO EL MEGAPACK AHORA" data-id="element-264" />
          </div>
        </motion.div>
      </div>
    </section>;
}